import { useState } from "react";
import {
    useGetGoodsHistory,
    goodsHistoryMethod,
} from "../../../../../common/hooks/console/management/goods/useGetGoodsHistory";

/*
// 상품 변경 이력.
//
// 상품을 수정하면 그 상품으로 나간 과거 주문의 표기까지 함께 바뀌고, 삭제하면 상품코드가
// 사라진다. 목록만 봐서는 누가 언제 무엇을 바꿨는지 알 수 없어 이 화면을 둔다.
// 이력 도입(2026-10) 이전 기록은 요청 로그에서 옮겨온 것이라 변경 항목이 비어 있을 수 있다.
*/
const GoodsHistory = ({ productIdx }: { productIdx: number }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);

    const { data, isLoading } = useGetGoodsHistory(open ? productIdx : null, page);

    const methodLabel = (code: number | null) => (code !== null && goodsHistoryMethod[code]) || "변경";

    return (
        <div className="flex flex-col">
            <button
                type="button"
                onClick={() => {
                    setOpen(prev => !prev);
                    setPage(1);
                }}
                className="self-start text-sm underline text-gray2"
            >
                변경이력 {open ? "닫기" : "보기"}
            </button>

            {open && (
                <div className="mt-2 border-t-2 border-gray2">
                    {isLoading && <p className="py-3 text-sm text-gray3">불러오는 중입니다.</p>}

                    {!isLoading && (data?.data_list?.length ?? 0) === 0 && (
                        <p className="py-3 text-sm text-gray3">변경 이력이 없습니다.</p>
                    )}

                    {data?.data_list?.map(item => (
                        <div key={item.product_history_idx} className="flex flex-col gap-1 border-b border-gray4 py-2">
                            <div className="flex items-center gap-2 text-sm">
                                <span className="font-bold">{methodLabel(item.method_code)}</span>
                                <span className="text-gray2">{item.m_name || "-"}</span>
                                <span className="ml-auto text-gray3">{item.reg_date}</span>
                            </div>
                            <p className="text-sm break-all">{item.contents}</p>
                        </div>
                    ))}

                    {(data?.last_page ?? 0) > 1 && (
                        <div className="flex items-center justify-center gap-3 py-2 text-sm">
                            <button
                                type="button"
                                disabled={page <= 1}
                                onClick={() => setPage(prev => prev - 1)}
                                className="disabled:text-gray4"
                            >
                                이전
                            </button>
                            <span className="text-gray2">
                                {data?.current_page} / {data?.last_page}
                            </span>
                            <button
                                type="button"
                                disabled={page >= (data?.last_page ?? 1)}
                                onClick={() => setPage(prev => prev + 1)}
                                className="disabled:text-gray4"
                            >
                                다음
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default GoodsHistory;
